import React from "react"
import Title from "./Title"
import Project from "./Project"
import { Link } from "gatsby"
const Projects = ({projects,title,isShowMoreEnabled}) => {

  return (<section className='section projects'>
    <Title title={title}/>
    <div className='section-center projects-center'>
      {
        projects.map((project,idx)=>{
          return <Project key={project.id} index={idx} {...project}/>
        })
      }
    </div>
      {isShowMoreEnabled && <Link to='/projects' className='btn center-btn'> Projects</Link>}
  </section>)
}

export default Projects
